var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"og-chat-embed"},[_c('ChatbotWidget',{attrs:{"api-url":_vm.apiUrl,"api-token":_vm.apiToken,"layout":"sidebar","embedded":true,"start-open":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }